export const ja = {
  'ConnectionNameForm.Nickname': 'ニックネーム',
  'ConnectionNameForm.Guidename': 'ガイド名',
  'ConnectionImage.Character': 'キャラ',
  'ConnectionStartDate.DateAndTime': 'ツアー開始時間',
  'ConnectionStartDate.StartDateTime': '{year}年{month}月{day}日 {time}',
  'ConnectionBeforeTour.DateAndTime': 'ツアー開始時間',
  'ConnectionBeforeTour.Message': '開始10分前から入場できます。',
  'ConnectionBeforeTour.RefreshDateAndTime': '画面更新時の日時',
  'ConnectionBeforeTour.StartDate': '{year}年{month}月{day}日 {time}',
  'ConnectionBeforeTour.Refresh': '画面を更新する',
  'ConnectionButton.Guide.Start': 'はじめる',
  'ConnectionButton.User.Start': 'はじめる',
  'ConnectionBrowse.BrowseMode': '閲覧モードで入る',
  'ConnectionBrowse.BrowseModeForVtour': 'ツアーを見学する',
  'ConnectionModal.MapTitle1':
    '「{title}」のバーチャルマップを使うには、ニックネームとキャラを設定して、「はじめる」を押してください。',
  'ConnectionModal.MapTitle2':
    '「{title}」のバーチャルマップを使うには、{text}ニックネームとキャラを設定して、「はじめる」を押してください。',
  'ConnectionModal.Current': '現在の参加者',
  'ConnectionModal.PeopleJA': '名',
  'ConnectionModal.Maximum': '（参加定員 {limit} 名）',
  'ConnectionModal.Full1': '定員に達しました。',
  'ConnectionModal.Full2':
    '画面下の「ツアーを見学する」からお入りください。ツアーの様子を見ることができます。',
  'ConnectionParticipants.Current': '現在の参加者',
  'ConnectionParticipants.PeopleJA': '名',
  'ConnectionParticipants.Maximum': '（参加定員 {limit} 名）',
  'LocateButton.Share': '現在地',
  'LocateButton.Stop': '停止',
  'VmapContainer.LocateButton.ConfrimMessage':
    '「現在地」モードに切り替わります。他のユーザーにあなたの位置情報が共有されます。よろしいですか？',
  'UserList.Guide': 'ガイド',
  'ExitButton.Exit': 'おわる',
  'VmapContainer.FinishedTour.AlertMessage':
    'ツアーの終了時間となりました。ご参加ありがとうございました。',
  'VmapContainer.ExitButton.ConfirmMessage': 'バーチャルマップを終了しますか？',
  'VmapContainer.DeportedUser.AlertMessage':
    'ガイドの操作により、ツアー参加者から外されました。「見学モード」に切り替わります。',
  'StrolyMap.DeportUser.ConfirmMessage': 'この参加者を非表示にしますか？',
  'StrolyMap.LocateButton.AlertMessage': '現在地は地図の範囲外です。',
  'LandmarkList.All': 'すべて',
  'LandmarkList.None': '表示しない',
  'Landmark.Move': 'スポットを確認する',
  'CommentConatainer.CheckLandmark': '✅「{landmark}」をチェックしました！',
  'CommentForm.ButtonLabel': 'コメント',
  'CommentSendMessage.Placeholder': 'コメント',
  'DisconnectionDialog.ConfirmMessage': 'このツアーを終了しますか？',
  'DisconnectionDialog.Notice': '終了すると',
  'DisconnectionDialog.Demerit1': '再入場時に、過去のメッセージが見れない。',
  'DisconnectionDialog.Demerit2-1': 'ツアー参加者数が上限を超えている場合は、',
  'DisconnectionDialog.Demerit2-2': '参加者として再入場できない。',
  'DisconnectionDialog.Cancel': 'キャンセル',
  'DisconnectionDialog.Exit': '終了する',
};

export const en = {
  'ConnectionModal.MapTitle1':
    'To start the virtual tour of "{title}", set nickname and click the "START THE TOUR" button.',
  'ConnectionModal.MapTitle2':
    'To start the virtual tour of "{title}", set nickname and click the "START THE TOUR" button.',
  'ConnectionNameForm.Nickname': 'Nickname',
  'ConnectionNameForm.Guidename': 'Guide name',
  'ConnectionImage.Character': 'Select a character',
  'ConnectionStartDate.DateAndTime': 'Start time & Date',
  'ConnectionStartDate.StartDateTime': '{year}/{month}/{day} {time}',
  'ConnectionBeforeTour.DateAndTime': 'Start time & Date',
  'ConnectionBeforeTour.Message':
    'You can enter from 10 minutes before the start.',
  'ConnectionBeforeTour.RefreshDateAndTime': 'Last time viewed',
  'ConnectionBeforeTour.StartDate': '{year}/{month}/{day} {time}',
  'ConnectionBeforeTour.Refresh': 'Refresh this screen',
  'ConnectionButton.Guide.Start': 'Start the tour',
  'ConnectionButton.User.Start': 'Join as a participant',
  'ConnectionBrowse.BrowseMode': 'Join as an observer',
  'ConnectionBrowse.BrowseModeForVtour': 'Join as an observer',
  'ConnectionModal.Current': 'Current number of participants',
  'ConnectionModal.PeopleJA': ' ',
  'ConnectionModal.Maximum': '(Capacity {limit} participants)',
  'ConnectionModal.Full1': 'Participant spots are full.',
  'ConnectionModal.Full2':
    'You can still observe the tour by clicking on the link below.',
  'ConnectionParticipants.Current': 'Current number of participants',
  'ConnectionParticipants.PeopleJA': ' ',
  'ConnectionParticipants.Maximum': '(Capacity {limit} participants)',
  'LocateButton.Share': 'GPS',
  'LocateButton.Stop': 'STOP',
  'VmapContainer.LocateButton.ConfrimMessage':
    'Switch to "current location" mode. Your current location information will be used to share with others. Is that OK?',
  'UserList.Guide': 'Guide',
  'ExitButton.Exit': 'EXIT',
  'VmapContainer.FinishedTour.AlertMessage':
    'This tour has ended. Thank you for joining!',
  'VmapContainer.ExitButton.ConfirmMessage':
    'Do you want to leave the virtual map?',
  'VmapContainer.DeportedUser.AlertMessage':
    'You have been removed as a participant by the Guide. You can rejoin the tour as an Observer.',
  'StrolyMap.DeportUser.ConfirmMessage': 'Do you want to ban this participant?',
  'StrolyMap.LocateButton.AlertMessage':
    'Your current location is out of map area.',
  'LandmarkList.All': 'All',
  'LandmarkList.None': 'None',
  'Landmark.Move': 'Check the spot',
  'CommentConatainer.CheckLandmark': '✅ Take a look at "{landmark}"',
  'CommentForm.ButtonLabel': 'MESSAGE',
  'CommentSendMessage.Placeholder': 'Message',
  'DisconnectionDialog.ConfirmMessage': 'Do you want to leave the virtual map?',
  'DisconnectionDialog.Notice': 'Notice',
  'DisconnectionDialog.Demerit1':
    "You can't see the past messages when you reenter.",
  'DisconnectionDialog.Demerit2-1':
    'If the number of participants in a virtual tour exceeds the limit, ',
  'DisconnectionDialog.Demerit2-2': 'you cannot start as a participant.',
  'DisconnectionDialog.Cancel': 'CANCEL',
  'DisconnectionDialog.Exit': 'EXIT',
};
